{
  "R": [0, 0, 0, 0],
  "G": [0, 1, 128, 255],
  "B": [0, 222, 127, 32],
  "A": [0, 0, 64, 128],
  "I": [0, 1, 128, 255]
}
